export default "__VITE_ASSET__BTefODpb__"